<template>  
  <div class="expert-faq__container">
    <div class="expert-faq__title">
      <h3 class="expert-faq__text">FAQ's</h3>
    </div>
    <accordion v-for="(faq, subindex) in faqsList" :key="subindex" :heading="faq.question" iconSize="10px" activeIcon="minus" :auto-close="false" theme="faq" class="accordion--faq accordion--faq-dark">
      <div class="accordion__answer client-generated" v-html="faq.answer"></div>
    </accordion>
  </div>
</template>

<script>
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue'
import Accordion from '@/scripts/components/basic/Accordion.vue'

export default {
  name: 'ExpertFAQ',
  components: {
    AccordionGroup,
    Accordion
  },
  props: {
    faqsList: {
      type: Array,
      default: () => ([{}])
    }
  }
}
</script>

<style lang="scss" scoped>
.expert-faq {

  &__container {
    margin: 0 auto;
    max-width: 861px;
    padding-top: 56px;
    padding-bottom: 56px;

    @include mobile-only {
     padding: 20px;
    }
  }
 
  &__text {
    color: $color-black-900;
    font-family: $font-family-primary;
    font-size: 32px;
    letter-spacing: 0;
    line-height: 42px;
    text-align: center;
  }

  &__title {
    margin-top: 71px;
    margin-bottom: 71px;

    @include mobile-only {
      margin-top: 31px;
      margin-bottom: 31px;
    }
  }

  @include tablet-up {
    padding-top: 16px;
  }
  
}
</style>